export const AuthErrorEnum = {
  '-4001': 'Invalid Credentials Provided',
  '-4002': 'Email Already Exists',
  '-4003': 'External Service Error',
  '-4004': 'Unsupported Authentication Method',
  '-4005': 'Missing Required Fields',
  '-4006': 'Too Many Attempts, Try Again Later',
  '-4007': 'Account Disabled',
  '-4008': 'Account Not Verified',
  '-4009': 'Invalid Email Format',
  '-4010': 'Invalid Phone Number',
  '-4011': 'Token Expired',
  '-4012': 'Invalid Token',
  '-4013': 'Session Expired',
  '-4014': 'Access Denied',
  '-4015': 'Account Locked',
  '-4016': 'Account Not Found',
  '-4017': 'Password Too Weak',
  '-4018': 'Passwords Do Not Match',
  '-4019': 'Password Expired',
  '-4020': 'Phone Number Already Exists',
  '-4021': 'Maximum Devices Exceeded',
  '-4022': 'Device Not Recognized',
  '-4023': 'Rate Limit Exceeded',
  '-4024': 'Service Unavailable',
  '-4025': 'Operation Timed Out',
  '-4026': 'Email Not Verified',
  '-4027': 'Phone Number Not Verified',
  '-4028': 'Invalid Verification Code',
  '-4029': 'Verification Code Expired',
  '-4030': 'Too Many Verification Attempts',
  '-4031': 'Invalid LINE Token',
  '-4032': 'Invalid Google Token',
  '-4033': 'Invalid Facebook Token',
  '-4034': 'SMS Verification Needed',
  '-4035': 'Invalid SMS Verification Code',
  '-4036': 'SMS Verification Code Not Sent',
  '-4037': 'Verification In Progress',
  '-4038': 'Already Verified',
  '-4039': 'Check Your Phone For SMS Code',
  '-4040': 'SMS Rate Limit Exceeded',
  '-4041': 'SMS Verification Failed',
  '-4042': 'Phone Number Verification Required',
  '-4043': 'Phone Number Not Associated With Any Account',
  '-4044': 'SMS Verification Code Already Used',
  '-4045': 'Invalid Sex Selected',
  '-4047': 'SMS Code Has Expired Or Does Not Exist',

  '-4046': 'JWT Token Creation Failed',
  '-4048': 'JWT Token Not Yet Valid',
  '-4049': 'JWT Token Signature Invalid',
  '-4050': 'JWT Token Missing',
  '-4051': 'JWT Token Cannot Be Refreshed',
  '-4052': 'JWT Token Refresh Failed',
  '-4053': 'JWT Token Claims Invalid',
  '-4054': 'JWT Token Audience Invalid',
  '-4055': 'JWT Token Issuer Invalid',
  '-4056': 'Unsupported JWT Token Type',
  '-4057': 'JWT Token Processing Error',

  '-4058': 'User Needs To Register But Email Not Provided',
  '-4067': 'No Data In Member And MemberApp ',
  '-4059': 'User Needs To Register But Email Provided',
  '-4060': 'SMS Verification Completed But Registration Process Not Completed',
  '-4061': 'SMS Verification Completed But Registration Process Completed',
  '-4062': 'Add Member To Temp Table Failed',
  '-4063': 'Add MgmMemberList To Table Failed',
  '-4064': 'Add Member To Table Failed',
  '-4065': 'Register Failed',
  '-4066': 'Invalid Token',
  '-4068': 'Third Party Id Missing',

  '-4069': 'User Has Active Subscription',
  '-4070': 'User Purge Failed',
  '-4071': 'Invalid Apple Token',
  '-4072': 'User Needs To Complete Registration Process'
} as const;
